// extracted by mini-css-extract-plugin
module.exports = {"skillsGrid":"skills_skillsGrid__3P45N","skillsTitle":"skills_skillsTitle__2_2tE","coloredBorder":"skills_coloredBorder__iRxpu"};